import { SelectHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export default function Select({ className, children, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
    return (
        <select
            className={cn(
                "w-full rounded-xl border border-rose-100 bg-white px-3 py-2 text-sm outline-none transition focus:border-brand-300",
                className
            )}
            {...props}
        >
            {children}
        </select>
    );
}